import { defineComponent } from '@vue/composition-api';
import FilterToggler from '@/components/Filters/FilterToggler.vue';
export default defineComponent({
    components: { FilterToggler },
});
